var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-base-table-body-cell',_vm._b({attrs:{"render-when-empty":""}},'iv-base-table-body-cell',{ ..._vm.$attrs, ..._vm.$props },false),[_c('ivc-user-role',{attrs:{"value":_vm.value}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }